export interface CardData {
    id: any;
    image: any;
    title: string;
    link:string;
}
export const servicesCard : CardData [] = [
    {
        id: 1,
        image: require("../../../assets/images/services/advocate.png"),
        title: 'Lawyers',
        link:'',
    },
    {
        id: 2,
        image: require("../../../assets/images/services/charging-station.png"),
        title: 'Charging Station',
        link:'/personal-services/charging-stations'
    },
    {
        id: 3,
        image: require("../../../assets/images/services/company.png"),
        title: 'Insurance Companies',
        link:''
    },
    {
        id: 4,
        image: require("../../../assets/images/services/protection.png"),
        title: 'MOT Centres',
        link:''
    },
    {
        id: 5,
        image: require("../../../assets/images/services/car.png"),
        title: 'Motor Dealers',
        link:''
    },
    {
        id: 6,
        image: require("../../../assets/images/services/bidding.png"),
        title: 'Motor Auctioneers',
        link:''
    },
    {
        id: 7,
        image: require("../../../assets/images/services/car-crash.png"),
        title: 'Salvage Dealers',
        link:''
    },
    {
        id: 8,
        image: require("../../../assets/images/services/finance.png"),
        title: 'Finance Companies',
        link:''
    },
    {
        id: 9,
        image: require("../../../assets/images/services/Cars.png"),
        title: 'Fleet Operators',
        link:''
    },
    {
        id: 10,
        image: require("../../../assets/images/services/repair-service.png"),
        title: 'Car Buying Services',
        link:''
    }
]
export const chargingCards:CardData[]=[
    {
        id: 1,
        image: require("../../../assets/images/services/find-station.png"),
        title: 'Charging Stations',
        link:''
    },
    {
        id: 2,
        image: require("../../../assets/images/services/earn-with-station.png"),
        title: 'Earn with us',
        link:'/personal-services/earn-with-us'
    },
]
export const earnWithUs:CardData[]=[
    {
        id: 1,
        image: require("../../../assets/images/services/RegisterChargingStattion.png"),
        title: 'Register Charging Station',
        link:'charginStation'
    },
    {
        id: 2,
        image: require("../../../assets/images/services/RentYourSpace.png"),
        title: 'Rent Your Space',
        link:'rentYourSpace'
    },
]